import { EntityValidationRules } from "services/validationService";
import Notice, { SignatureType } from "./notice";

export const NoticePowerOfAttorneyRules: EntityValidationRules<Notice> = {
  _powerOfAttorneyFilesBase64: {
    requiredIf: {
      condition: (entity: Notice) =>
        !!(
          entity._signatureType === SignatureType.DataBox &&
          ((entity.vehicleOperator &&
            entity.vehicleOperator.naturalPerson &&
            entity.vehicleOperator.naturalPerson.isRepresentedByProxy) ||
            (entity.vehicleOperator && entity.vehicleOperator.isLegalPerson))
        ),
      customMessage: "documentUploadRequired",
    },
  },
};
export default class Omission extends Notice {}
